import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { SystemMasterSelect } from '../../../Components/helper';

function BtnSort({ onBtnClick, options, val, isProductArchived }) {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      title={t('FILTER.SORT')}
      className={val ? 'filter-btn filter-button_delete active' : 'filter-btn filter-button_delete'}
      disabled={isProductArchived}
    >
      <OverlayTrigger
        placement={t('TAKING_DATES.BUTTON')}
        trigger="click"
        rootClose
        overlay={
          <Popover className="custom-popover">
            <Popover.Content>
              <Select isClearable options={options} value={val} onChange={onBtnClick} styles={SystemMasterSelect} placeholder={t('FILTER.SORT_BY')} />
            </Popover.Content>
          </Popover>
        }
      >
        <i className="icon-Sort-By f-26" />
      </OverlayTrigger>
      {/* <span className="text-icon">{t("FILTER.SORT")}</span> */}
    </button>
  );
}

export default BtnSort;
